var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card p-3 shadow-sm"},[(_vm.loading)?[_c('app-loading')]:[_c('ci-list',{attrs:{"entity":_vm.type,"entity_id":_vm.id,"entity_vessel_id":_vm.pscReport.vessel_id},on:{"resetCompanyInstructions":function($event){return _vm.initialize(false)}}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }